import React from "react";

import { ReactComponent as InteracIcon } from "./chatbot_icon.svg";

const InteracBotAvatar = () => {
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <div className="react-chatbot-kit-chat-bot-avatar-container">
        <InteracIcon className="react-chatbot-kit-chat-bot-avatar-icon" />
      </div>
    </div>
  );
};

export default InteracBotAvatar;